// src/components/onboarding/ProgressBar.tsx
import React from 'react';

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep, totalSteps }) => {
  const progressPercentage = ((currentStep -1) / (totalSteps -1)) * 100; // Adjust calculation based on 0 or 1 indexing

  return (
    <div className="w-full bg-gray-200 rounded-full h-2 dark:bg-gray-700 mb-8">
      <div
        className="bg-blue-600 h-2 rounded-full transition-all duration-500 ease-out"
        style={{ width: `${progressPercentage}%` }}
        role="progressbar"
        aria-valuenow={currentStep}
        aria-valuemin={1}
        aria-valuemax={totalSteps}
        aria-label={`Step ${currentStep} of ${totalSteps}`}
      ></div>
      <p className="text-center text-sm text-gray-600 dark:text-gray-400 mt-2">
        Step {currentStep} of {totalSteps}
      </p>
    </div>
  );
};

export default ProgressBar;